export default "__VITE_ASSET__Dd5fWTH7__"